export default __webpack_public_path__ + "static/media/icon-freedom.7788f0fe.svg";